// extracted by mini-css-extract-plugin
export default {"main":"Login_main__AS6jK","box":"Login_box__h+Ibl","btnLogin":"Login_btnLogin__htSZ-"};